import { Vendor_Approval_Statuses_Enum } from '@main/graphql/types.generated';
import dayjs from 'dayjs';

export const getVendorPatExpirationAt = () => dayjs().add(6, 'month').toISOString();

export const LEGACY_VENDOR_APPROVAL_STATUSES = [
  Vendor_Approval_Statuses_Enum.Pending,
  Vendor_Approval_Statuses_Enum.Accepted,
  Vendor_Approval_Statuses_Enum.Rejected,
] as const;

export function isLegacyVendorApprovalStatus(
  status: string,
): status is Vendor_Approval_Statuses_Enum {
  return LEGACY_VENDOR_APPROVAL_STATUSES.includes(
    status as (typeof LEGACY_VENDOR_APPROVAL_STATUSES)[number],
  );
}
